import api from './client';

export interface ActionItem {
  priority: 'high' | 'medium' | 'low';
  action: string;
  rationale: string;
}

export interface CompetitorAnalysis {
  id: number;
  competitor_name: string;
  competitor_url: string | null;
  competitor_niche: string | null;
  summary: string | null;
  competitor_strengths: string[];
  competitor_weaknesses: string[];
  opportunities: string[];
  threats: string[];
  positioning_gaps: string[];
  action_items: ActionItem[];
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export interface AnalyzePayload {
  name: string;
  url?: string;
  niche?: string;
  notes?: string;
}

export const competitorApi = {
  list: (page = 1) =>
    api.get<{ data: CompetitorAnalysis[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/competitors?page=${page}`
    ),

  analyze: (payload: AnalyzePayload) =>
    api.post<{ data: CompetitorAnalysis }>('/competitors/analyze', payload),

  show: (id: number) => api.get<{ data: CompetitorAnalysis }>(`/competitors/${id}`),

  destroy: (id: number) => api.delete(`/competitors/${id}`),
};
